export default __webpack_public_path__ + "static/media/KOF.8b4ff8be.jpg";